export default __webpack_public_path__ + "static/media/django-negative.427db731.svg";